/**
 * Learn more about Light and Dark modes:
 * https://docs.expo.io/guides/color-schemes/
 */

import * as React from 'react'
import { Platform, Text as DefaultText, View as DefaultView } from 'react-native'
import Colors from '../constants/Colors'
import useColorScheme from '../hooks/useColorScheme'
// import { useFonts } from 'expo-font'
// import * as SplashScreen from 'expo-splash-screen'

export function useThemeColor(
	props: { light?: string; dark?: string },
	colorName: keyof typeof Colors.light & keyof typeof Colors.dark
) {
	const theme = useColorScheme()
	const colorFromProps = props[theme]

	if (colorFromProps) {
		return colorFromProps
	} else {
		return colorName === 'background' ? 'transparent' : 'black'
		// return Colors[theme][colorName]
	}
}

type ThemeProps = {
	lightColor?: string
	darkColor?: string
}

export type TextProps = ThemeProps & DefaultText['props']
export type ViewProps = ThemeProps & DefaultView['props']

// SplashScreen.preventAutoHideAsync()

export function Text(props: TextProps) {
	// const [loaded, error] = useFonts({
	// 	Roboto: require('../assets/fonts/Roboto-Regular.ttf'),
	// 	Western: require('../assets/fonts/western.otf'),
	// })
	// console.log(loaded)
	// React.useEffect(() => {
	// 	if (loaded || error) {
	// 		SplashScreen.hideAsync()
	// 	}
	// }, [loaded, error])

	// if (!loaded && !error) {
	// 	return null
	// }

	// const ORG_FONT_MAPPER = {
	// 	'CA-BC-Vancouver-FoodRepublic': 'System',
	// 	'gkb-mississauga': 'System',
	// 	clubkitchen: 'Western',
	// 	modkitchen: 'Roboto',
	// 	'CA-BC-Vancouver-MemphisBlues': 'Western',
	// }

	const { style, lightColor, darkColor, ...otherProps } = props
	const color = useThemeColor({ light: lightColor, dark: darkColor }, 'text')

	return (
		<DefaultText
			style={[
				{
					color,
					fontFamily: Platform.OS === 'web' ? 'System' : 'DefaultFont',
				},
				style,
			]}
			{...otherProps}
		/>
	)
}

export function View(props: ViewProps) {
	const { style, lightColor, darkColor, ...otherProps } = props
	return <DefaultView style={style} {...otherProps} />
}
